const keycloak =
  process.env.NODE_ENV === "test"
    ? {}
    : JSON.parse(process.env.REACT_APP_BACKEND_KEYCLOAK);
const brandFilterKeys = [
  "ABC",
  "DEF",
  "GHI",
  "JKL",
  "MNO",
  "PQR",
  "STU",
  "VWX",
  "YZ#",
];
const test = "a";
const expiryTime = 1528897271083;
const filterInitialLength = 14;
const filterKeys = {
  Color: "f-co",
  Price: "f-pr",
  Occasion: "f-oc",
  Brand: "f-br",
  delivery_time: "f-dt",
};
const searchQuerySeparator = "--";
const subPromoSeparator = "__";
const priceSeparator = "-";
const footerUrls = {
  privacypolicy: "/privacypolicy",
  termsconditions: "/termsconditions",
  whoweare: "/whoweare",
  customercare: "/customercare",
  contactus: "/contactus",
  facebook: "https://www.facebook.com/heynnnow",
  intagram: "https://www.instagram.com/heynnnow",
};
const facebook = {
  appId: process.env.REACT_APP_FACEBOOK,
  version: "v2.10",
  scope: "email",
  url: "//connect.facebook.net/en_US/all.js",
  xfbml: true,
};
const gmail = {
  appId: process.env.REACT_APP_GMAIL,
  cookiepolicy: "single_host_origin",
  scope: "profile email",
};
const nnnowColors = [
  "#33cc66",
  "#ff3366",
  "#b2d235",
  "#2ba2e4",
  "#ffa500",
  "#ea0020",
];

const pageType = {
  listing: "product-listing-anonymous",
  brands: "brands",
  pdp: "product-display",
  storeLocator: "store-locator",
  home: "home",
  searchPage: "search",
  myBag: "mybag",
  myAccount: "account",
  favourite: "favorites.shortlist",
  categoryTwoTemplate: "CategoryTemplateII",
};
const omniViewimageBasePath =
  "https://static.nnnow.com/client/assets/images/omnipopup/";

const scrollTime = {
  slow: 1000,
  fast: 100,
};
const blackBoltUrl = ["token", "login", "registerUser"];
const blackboltConfig = {
  ERROR_MSG: "Oops Something went wrong. Please try again later.",
  grant_type: "password",
  email: "EMAIL",
  mobile: "SMS",
  socialGrantType: "social_token",
  google: "GOOGLE",
  facebook: "FACEBOOK",
  ERROR_CODE: ["409", "401","404"],
  channel: "odin",
}
const blackBoltVersion = "v2";
const requiredKeysForListing = ["q", "sort", "p-st", "p-dl", "r"];
const DEF_META_DATA = {
  title: "NNNOW.com Discover and Shop Latest Fashion and Clothes Online.",
  description:
    "Online Shopping for Men, Women and Kids. Buy a wide range of clothes, apparel, accessories, shoes online at NNNOW.com. Fast shipping , 15 days Return,  Cash on Delivery",
  keywords:
    "Online shopping, Online shopping India, Men shopping, women online shopping, Shop for accessories, shop for clothing, kids online shopping, Arrow, Gap, Sephora, U. S. Polo Assn., Aeropostale, Gant, Nautica, Flying Machine, The Children’s Place, Ed Hardy, True Blue, Elle, Izod, Ruf & Tuf, Unlimited",
  imageURL: "https://static.nnnow.com/client/assets/images/nnnow-logo-200.png",
  pageURL: "https://www.nnnow.com",
  fb_appID: "383470072074863",
  google_site_verification: "P5hXMQ-ATML8ShhpCLa_wzcyFwyGRsJdr92b6YuBSIg",
};

const PDP_RETURNS = {
  returnPolicy:
    'How to return this item? Ship it back to NNNOW or have us pick it up within 15 days. Just keep it unwashed, undamaged and with tags intact so it passes our quality checks. See <a class="nw-pdp-desktopaccordiontnc" href="/customercare" target="_blank">FAQs</a> on our Returns Policy for more.',
  noReturnPolicy:
    "This item can’t be returned — our Returns Policy doesn’t cover innerwear, lingerie, fragrances and beauty products.",
};
const PDP_CAROUSEL_DEFAULT_VIEWALL_TEXT = "VIEW ALL";
const PDP_CAROUSEL_SIZE = {
  XS: 2,
  SM: 2,
  MD: 3,
  LG: 5,
};

const PDP_CAROUSEL_HEADINGS = {
  IN_THIS_LOOK: "IN THIS LOOK",
  SIMILAR_PRODUCTS: "SIMILAR PRODUCTS",
  RECENTLY_VIEWED: "RECENTLY VIEWED",
};
const APP_BREAKPOINTS = {
  XS: 768,
  SM: 992,
  MD: 1200,
};
const GOOGLE_KEY = "AIzaSyDZLw2YISKAU49JefvGNs1TiSEVPdi7ao8";
const FB_SHARE_TITLE = "odin NNNOW";

const STORAGE_KEYS = {
  RECENTLY_VIEWED: "recentlyViewedItems",
  LAST_USED_PINCODE: "recentlyUsedPincode",
};

const CACHE_SETTINGS = {
  DONOT_CACHE: {
    "Cache-Control": "no-store, no-cache, must-revalidate",
  },
};

const HOME_PAGE_URL = process.env.REACT_APP_BASE_PATH_URL;
const DONOT_SHOW_OCCASION_FILTER_IDS = ["se"];
const PDP_CAROUSEL_MAX_LIMIT = 20;
const STATIC_GETTYPE_RESPONSE = {
  staticPage: true,
  documentType: null,
  type: "",
};
const STATIC_ROUTES = {
  NEW: ["search", "products", "product-listing", "store-locator"],
  OLD: [
    "mybag",
    "checkout",
    "orderconfirmation",
    "reset-password",
    "logs",
    "whoweare",
    "contactus",
    "sdtnc",
    "privacypolicy",
    "termsconditions",
    "apps",
    "gaptncs",
    "customercare",
    "loyalty",
    "heynnnow",
    "sitemap",
    "account",
    "mynow",
    "payment",
    "favorites",
    "shortlists",
    "brands",
    "stories",
    "orderdetails",
    "returns",
    "product-chooser",
    "choose-method",
    "store-selector",
    "neft",
    "confirmation",
    "blog-landing",
    "BlogPageII",
    "BlogPageI",
    "BlogPageIII",
    "brandslist",
    "ss16-end-of-season-sale",
    "storebrand",
    "noresults",
    "customer-login",
    "logout",
    "mygapstore",
  ],
};
const EXCLUDE_STORY_BACKGROUND_COLOR = [
  "homeMasterTemplate",
  "brandMasterTemplate",
];
const GETTYPE_PAGEWISE_VALUES = {
  UNKNOWN: ["unknown"],
  LISTING: ["Collection", "ProductListBanner", "Brand"],
  PDP: ["Style"],
  MASTER_TEMPLATE: [
    "homeMasterTemplate",
    "brandMasterTemplate",
    "collectionMasterTemplate",
    "categoryMasterTemplate",
    "BrandMasterTemplate2",
    "BrandMasterTemplate3",
  ],
};
const SUPPORTED_GETTYPE_VALUES = [].concat(
  ...Object.keys(GETTYPE_PAGEWISE_VALUES).map(
    item => GETTYPE_PAGEWISE_VALUES[item],
  ),
);
const FULL_WIDTH_MASTER_TEMPLATES = [
  "homeMasterTemplate",
  "brandMasterTemplate",
];

const OLD_MASTER_TEMPLATES = [
  "homeMasterTemplate",
  "brandMasterTemplate",
  "collectionMasterTemplate",
  "categoryMasterTemplate",
];
const MASTER_TEMPLATE_COMPONENT_MAPPING_MOBILE = {
  leftNav: "LeftNavMobile",
};

const MASTER_TEMPLATE_COMPONENT_MAPPING = {
  blocks: "Blocks",
  leftNav: "LeftNav",
  banner: "Banner",
  topBar: "TopBar",
  heroBanner: "TopBanner",
  topBanner: "TopBanner",
  youtubeVideo: "VideoComponent",
  sephoraCarousel: "BannerCarousel",
  gapCarousel: "BannerCarousel",
  bannerCarousel: "BannerCarousel",
  story: "StoryComponent",
  tertiaryStorySection: "SectionCarousel",
  trendingTitle: "StoryTitle",
  secondaryStoriesTitle: "StoryTitle",
  primaryStories: "StoryMasonry",
  secondaryStories: "StoryMasonry",
  productCarousal: "ProductCarouselComponent",
  quickLinks: "QuickLinksComponent",
  dummy: "DummyComponent",
  NewArrival: "NewArrivalsCarousel",
  brandStory: "BrandStory",
};
/*
const NEW_MASTER_TEMPLATE_TYPES = [
  "BrandMasterTemplate2",
  "BrandMasterTemplate3",
  "categoryMasterTemplate",
];
 */
const MASTER_TEMPLATE_COMPONENT_CONFIGS = {
  TOP_BAR: {
    TIMEOUT: 3000,
    ADD_SUCCESS: "Brand Added Successfully",
    REMOVE_SUCCESS: "Brand Removed Successfully",
    LABELS: {
      FAVORITED: "favorited",
      UNFAVORITED: "unfavorited",
    },
  },
  LEFT_NAV: {
    HIDE: ["brandMasterTemplate"],
  },
  STORY: {
    SHOW_BORDER: ["brandmastertemplate3-ga"],
  },
  QUICK_LINKS: {
    TITLE: "QUICK LINKS",
  },
  PRODUCT_CAROUSEL: {
    ORIGIN: "master_template_product_carousel",
    API_LIMIT: 20,
    SIZES: {
      XS: 4,
      SM: 4,
      MD: 4,
      LG: 6,
    },
  },
  BANNER_CAROUSEL: {
    SCROLL_INTERVAL: 3000,
    TRANSITION_TIME: {
      SLOW: 600,
      QUICK: 600,
    },
  },
};
const BACKGROUND_COLOR_SET = [
  "#b5dce1",
  "#d7e0b1",
  "#f4e0e9",
  "#cfdaf0",
  "#f4e3c9",
  "#f4d9d0",
];
const BRAND_SPECIFIC_CONFIGS = {
  se: ["showMasterTemplateBrushStroke"],
};
const MAX_TITLEDESCRIPTIONHORIGENTAL_CHARECTER_DESKTOP = 33;
const MAX_TITLEDESCRIPTIONHORIGENTAL_CHARECTER_MOBILE = 43;
const PINCODE_LENGTH = 6;
const HEADER_HEIGHT = 100;
const OVERFLOW_HIDDEN = "hidden";
const OVERFLOW_AUTO = "auto";
const PIXEL_SCROLLED_LIMIT = 70;

export {
  STATIC_GETTYPE_RESPONSE,
  OLD_MASTER_TEMPLATES,
  SUPPORTED_GETTYPE_VALUES,
  EXCLUDE_STORY_BACKGROUND_COLOR,
  FULL_WIDTH_MASTER_TEMPLATES,
  BRAND_SPECIFIC_CONFIGS,
  BACKGROUND_COLOR_SET,
  MASTER_TEMPLATE_COMPONENT_CONFIGS,
  MASTER_TEMPLATE_COMPONENT_MAPPING_MOBILE,
  MASTER_TEMPLATE_COMPONENT_MAPPING,
  STATIC_ROUTES,
  GETTYPE_PAGEWISE_VALUES,
  DONOT_SHOW_OCCASION_FILTER_IDS,
  PDP_CAROUSEL_MAX_LIMIT,
  CACHE_SETTINGS,
  STORAGE_KEYS,
  FB_SHARE_TITLE,
  GOOGLE_KEY,
  APP_BREAKPOINTS,
  PDP_CAROUSEL_DEFAULT_VIEWALL_TEXT,
  PDP_CAROUSEL_HEADINGS,
  PDP_CAROUSEL_SIZE,
  PDP_RETURNS,
  subPromoSeparator,
  DEF_META_DATA,
  requiredKeysForListing,
  scrollTime,
  omniViewimageBasePath,
  pageType,
  brandFilterKeys,
  test,
  filterKeys,
  searchQuerySeparator,
  priceSeparator,
  footerUrls,
  gmail,
  facebook,
  filterInitialLength,
  nnnowColors,
  keycloak,
  blackBoltUrl,
  blackBoltVersion,
  blackboltConfig,
  expiryTime,
  HOME_PAGE_URL,
  MAX_TITLEDESCRIPTIONHORIGENTAL_CHARECTER_DESKTOP,
  MAX_TITLEDESCRIPTIONHORIGENTAL_CHARECTER_MOBILE,
  PINCODE_LENGTH,
  HEADER_HEIGHT,
  OVERFLOW_HIDDEN,
  OVERFLOW_AUTO,
  PIXEL_SCROLLED_LIMIT,
};



// WEBPACK FOOTER //
// ./src/constants/index.js